import ReportPageTemplate from "./Components/ReportPageTemplate";

export default function StatisticalReports() {
  const reportTypes = [
    { label: "Monthly Statistics", api: "/pms/reports/monthly-statistics" },
    { label: "Yearly Statistics", api: "/pms/reports/yearly-statistics" },
  ];

  return (
    <ReportPageTemplate
      title="Statistical Reports"
      desc="Monthly & yearly performance statistics"
      reportTypes={reportTypes}
    />
  );
}
